export enum LoginProviderEnum {
  Mab = 'MAB',
  Google = 'GOOGLE',
}
